import { useAuthSelector } from '@/store'

export default function useClaims() {
  const { token } = useAuthSelector()
  return token ? parseClaims(token) : {}
}

export function parseClaims(token: string) {
  const part = atob(token.split('.')[1])
  return JSON.parse(part)
}
